<main class="desktop container-fluid d-flex flex-column">
  <div class="row header-row" [style.z-index]="3">
    <div class="col-8">
      <app-scenario-images></app-scenario-images>
    </div>
    <div class="col-4 d-flex flex-column" [style]="{'align-items': ((customerConfig$ | async)?.logoPlacement === LogoPlacement.Left) ? 'flex-start' : ((customerConfig$ | async)?.logoPlacement === LogoPlacement.Center) ? 'center' : 'flex-end' }">
      <a [href]="getCustomerHomepageUrl() | async" *ngIf="logoUrl$ | async as logoUrl" target="_blank"><app-svg class="logo" [src]="logoUrl"></app-svg></a>
    </div>
  </div>

  <div class="row flex-grow-1 content-row">
    <section class="col-8 d-flex flex-column" [style.z-index]="1">
      <app-visualize-panel class="visualize-panel"></app-visualize-panel>
    </section>

    <section class="col-4 door-panel d-flex flex-column" [style.z-index]="4">
      <app-door-panel></app-door-panel>
    </section>
  </div>

  <app-visualize-footer-panel class="visualize-footer-panel" style="z-index: 4"></app-visualize-footer-panel>

  <app-refine-panel #refinePanel *ngIf="isRefineActive$ | async"></app-refine-panel>
</main>
<section class="footer-container">
  <a class="site-link" href="https://www.door-vision.com/privacy-policy"
     target="_blank">{{'redesign.privacyPolicy' |translate}}</a>
  <a class="site-link" href="https://www.door-vision.com/terms"
     target="_blank">{{'redesign.termsAndConditions' |translate}}</a>
  <a *ngIf="(isBrandingEnabled$ | async)" class="branding-link" href="https://www.door-vision.com/" target="_blank">
    <app-svg [src]="'door-vision/branding-logo.svg'"></app-svg>
  </a>
</section>
